import { useCallback } from "react"
import type { FactorRuleDisplay, FactorRuleDisplayType, FactorRuleField } from "../types"
import { FactorRulesTable } from "./table"

import "./style.scss"

export interface FactorRulesProps {
  exposure: FactorRuleDisplay[]
  composition: FactorRuleDisplay[]
  updateFactorRule: (rule: FactorRuleDisplay, field: FactorRuleField, value: string, ruleDisplayType: FactorRuleDisplayType) => void
  removeFactorRule: (rule: FactorRuleDisplay, ruleDisplayType: FactorRuleDisplayType) => void
  toggleActiveValue?: (rule: FactorRuleDisplay, ruleDisplayType: FactorRuleDisplayType) => void
  hasBase?: boolean
}

export default function FactorRules({
  exposure,
  composition,
  updateFactorRule,
  removeFactorRule,
  toggleActiveValue,
  hasBase = false,
}: FactorRulesProps) {
  const handleRemoveRule = useCallback((rule: FactorRuleDisplay, ruleDisplayType: FactorRuleDisplayType) => {
    if (rule?.id) {
      removeFactorRule(rule, ruleDisplayType)
    }
  }, [removeFactorRule])

  const handleUpdateRule = useCallback((rule: FactorRuleDisplay, field: FactorRuleField, value: string | undefined, ruleDisplayType: FactorRuleDisplayType) => {
    if (rule?.id && value !== undefined) {
      updateFactorRule(rule, field, value, ruleDisplayType)
    }
  }, [updateFactorRule])

  const handleToggleActiveValue = useCallback((rule: FactorRuleDisplay, ruleDisplayType: FactorRuleDisplayType) => {
    if (rule?.id && toggleActiveValue) {
      toggleActiveValue(rule, ruleDisplayType)
    }
  }, [toggleActiveValue])

  return (
    <div className="factor-rules-tables-container">
      <FactorRulesTable
        rules={exposure}
        handleUpdateRule={handleUpdateRule}
        handleRemoveRule={handleRemoveRule}
        handleToggleActiveValue={handleToggleActiveValue}
        ruleDisplayType="exposure"
        hasBase={hasBase}
      />
      <FactorRulesTable
        rules={composition}
        handleUpdateRule={handleUpdateRule}
        handleRemoveRule={handleRemoveRule}
        handleToggleActiveValue={handleToggleActiveValue}
        ruleDisplayType="composition"
        hasBase={hasBase}
      />
    </div>
  )
}
